export const CLAN_NAME_MAX_LENGTH = 32;

export function normalizeClanName(input: string, defaultName: string): string {
  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return defaultName;
  }

  if (trimmed.length <= CLAN_NAME_MAX_LENGTH) {
    return trimmed;
  }

  return trimmed.slice(0, CLAN_NAME_MAX_LENGTH);
}
